export const config = {
    appName: 'experts-package',
};
